module.exports = __webpack_public_path__ + "static/media/password.b22bfc2d.svg";